import { render, staticRenderFns } from "./OtherReceiptListFunc.vue?vue&type=template&id=2b102fdc&scoped=true"
import script from "./OtherReceiptListFunc.vue?vue&type=script&lang=js"
export * from "./OtherReceiptListFunc.vue?vue&type=script&lang=js"
import style0 from "./OtherReceiptListFunc.vue?vue&type=style&index=0&id=2b102fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b102fdc",
  null
  
)

export default component.exports